// extracted by mini-css-extract-plugin
export default {"StickyBlock":"bei_a bhi_bj"};